package com.eladfinish.bible.contest.screens.settings.ui.screens

import androidx.compose.runtime.Composable
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.common.settings.KeyValueSettings
import com.eladfinish.bible.contest.constants.BooleanConstants.ENABLE_PAIR_MATCHING_ALPHABETICAL_ORDER
import com.eladfinish.bible.contest.constants.BooleanConstants.ENABLE_PAIR_MATCHING_LONG_CLICK
import com.eladfinish.bible.contest.constants.BooleanConstants.ENABLE_PAIR_MATCHING_SORTABLE_LIST
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.KEY_PAIR_MATCHING_DRAG_ON_LONG_CLICK
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.KEY_PAIR_MATCHING_SORTABLE_LIST
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.PAIR_MATCHING_ALPHABETICAL_ORDER
import com.eladfinish.bible.contest.pair_matching_alphabetical_order_disabled
import com.eladfinish.bible.contest.pair_matching_alphabetical_order_enabled
import com.eladfinish.bible.contest.screens.settings.ui.preferences.PreferenceSwitch
import dev.icerock.moko.resources.compose.stringResource

@Composable
internal fun PairMatchingSettingsScreen(
    settings: KeyValueSettings,
) {
    PreferenceSwitch(
        title = "סדר הרשימה בהתאמת זוגות",
        key = PAIR_MATCHING_ALPHABETICAL_ORDER,
        defaultValue = ENABLE_PAIR_MATCHING_ALPHABETICAL_ORDER,
        summaryOn = stringResource(SharedRes.strings.pair_matching_alphabetical_order_enabled),
        summaryOff = stringResource(SharedRes.strings.pair_matching_alphabetical_order_disabled),
        settings = settings,
    )
    Divider()
    PreferenceSwitch(
        title = "משך הלחיצה לביצוע גרירה",
        key = KEY_PAIR_MATCHING_DRAG_ON_LONG_CLICK,
        defaultValue = ENABLE_PAIR_MATCHING_LONG_CLICK,
        summaryOn = "לחיצה ארוכה",
        summaryOff = "לחיצה קצרה",
        settings = settings,
    )
    Divider()
    PreferenceSwitch(
        title = "אופן הצגת זוגות עם מספר סידורי",
        key = KEY_PAIR_MATCHING_SORTABLE_LIST,
        defaultValue = ENABLE_PAIR_MATCHING_SORTABLE_LIST,
        summaryOn = "רשימה הניתנת למיון",
        summaryOff = "שני טורים",
        settings = settings,
    )
}
